import { render, staticRenderFns } from "./noticeIndex.vue?vue&type=template&id=1a68b1c4&scoped=true"
import script from "./noticeIndex.vue?vue&type=script&lang=js"
export * from "./noticeIndex.vue?vue&type=script&lang=js"
import style0 from "./noticeIndex.vue?vue&type=style&index=0&id=1a68b1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a68b1c4",
  null
  
)

export default component.exports